export interface BrandKitAccessData {
  id: string;
  is_public?: boolean | null;
}

export function canApplyBrandKit({
  hasProFeatures,
  kit,
}: {
  hasProFeatures: boolean;
  kit: BrandKitAccessData | null | undefined;
}): boolean {
  return Boolean(kit && (hasProFeatures || kit.is_public));
}

export function resolveRestoredBrandKitId({
  hasProFeatures,
  brandKitId,
  kits,
}: {
  hasProFeatures: boolean;
  brandKitId: string | null | undefined;
  kits: readonly BrandKitAccessData[];
}): string | null {
  if (!brandKitId) return null;
  const kit = kits.find((candidate) => candidate.id === brandKitId);
  return canApplyBrandKit({ hasProFeatures, kit }) ? brandKitId : null;
}
